import {IApiModel} from './api-model.interface';
import {BaseGroup} from './group-base.model';
import {Company} from './company.model';
import moment from 'moment';
import {CreatedByDto} from "../models/company/integrations.model";

export class Group extends BaseGroup implements IApiModel<Group> {
    declare tenant: any;
    tenantId: number;
    subGroups: Group[];
    companies: Company[];
    created_by: CreatedByDto | null;
    countryTranslate: string;
    fiscalMonth: string;
    parent: number;
    currentUserPermissions: string[];
    isSelected: boolean;
    isActive: boolean;
    currency: string;
    current_user_member_profile: any;

    static getEmptyModel(id: number): Group {
        return new Group({
            id: id,
            name: '',
            fiscalYearEnding: '',
            country: '',
            logo: '',
            logoContent: null,
            subGroups: [],
            order: 0,
            parent: null,
            currency: ''
        });
    }

    constructor(init?: Partial<Group>) {
        super(init);
        Object.assign(this, init);
    }

    getApiModel(): any {
        const formData = new FormData();
        if(this)
            formData.append('id', String(this.id));
        if(this.currency)
            formData.append('currency', this.currency);
        if (this.name) {
            formData.append('name', this.name);
        }
        if (this.fiscalYearEnding) {
            formData.append('fiscal_year_ending', this.fiscalYearEnding);
        }
        if (this.country) {
            formData.append('country', this.country);
        }
        if (this.order) {
            formData.append('order', String(this.order));
        }
        if (this.parent) {
            formData.append('parent', String(this.parent));
        }
        if (this.logoContent !== undefined && this.logoContent !== null) {
            let name = this.logoContent === null ? null : this.logoContent.name;
            formData.append('logo', this.logoContent, name);
        }
        return formData;
    }

    setFromApiModel(apiModel: any): this {
        this.id = apiModel.id;
        this.name = apiModel.name;
        this.fiscalYearEnding = apiModel.fiscal_year_ending;
        this.country = apiModel.country;
        this.logo = apiModel.logo;
        this.tenant = apiModel.tenant;
        this.tenantId = apiModel.tenant.id;
        this.subGroups = [];
        this.companies = [];
        this.parent = apiModel.parent;
        this.order = apiModel.order;
        this.currency = apiModel.currency;
        this.created_by = apiModel.created_by;
        this.current_user_member_profile = apiModel.current_user_member_profile;

        if (apiModel.companies) {
            this.companies.push(
            ...(<Array<any>>apiModel.companies)
                .map(i => new Company()
                    .setFromApiModel(i)));
        }

        if (apiModel.sub_groups) {
            this.subGroups.push(
            ...(<Array<any>>apiModel.sub_groups)
                .map(i => new Group()
                    .setFromApiModel(i)));
        }
        this.currentUserPermissions = apiModel.current_user_permissions;
        this.currentUserRole = apiModel.current_user_groups ? apiModel.current_user_groups[0] : null;
        this.firstTransactionDate = apiModel.first_transaction_date
             ? moment(apiModel.first_transaction_date, 'YYYY-MM-DD').toDate() : null;

        return this;
    }

    isOwner(userId, userModel): boolean {
        return userModel === 'tenant' && userId === this.tenantId;
    }

    isOwnerRole(): boolean {
        return this.currentUserRole === 'Owner';
    }

    hasCompanies(item: Group, result: boolean) {
        if (!result && item) {
            result = item.companies && item.companies.length > 0;
            if (!result && item.subGroups) {
                item.subGroups.forEach((subgroup) => {
                    result = this.hasCompanies(subgroup, result);
                });
            }
        }
        return result;
    }
}
